// extracted by mini-css-extract-plugin
export var actionSelect = "_so-0";